export function addCacheByKey(key, value) {
    const cacheStringified = JSON.stringify(value);
    localStorage.setItem(key, cacheStringified)
}
export function getCacheByKey(key) {

    const cacheJSON = localStorage.getItem(key);
    const cacheParsed = JSON.parse(cacheJSON)
    return cacheParsed

}
export function removeCacheByKey(key) {
    localStorage.removeItem(key)
}